export default __webpack_public_path__ + "static/media/wood-hardness.70fa8088.svg";